angular.module('unica_invitation_list.invitation_list_services')

.factory('InvitationListDeleteService', function ($http, getBaseApiURL) {

	var invitationListDeleteService = {};

	invitationListDeleteService.delete = function (invitationListId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-list/delete/' + invitationListId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return invitationListDeleteService;
});